import React, { useState } from 'react'
import MarkIcon from '@material-ui/icons/LocationOn'
import { OverlayTrigger, Popover } from 'react-bootstrap'

export default function MarksCoreComponent(props) {
  const { markerData, x, y } = props
  const { ConnectMode, Url, Color, Text } = markerData

  return (
    <div
      style={{
        top: y + '%',
        left: x + '%',
        position: 'absolute',
        zIndex: 1
      }}
    >
      {ConnectMode === 'popup' ? (
        <OverlayTrigger
          trigger='click'
          rootClose
          placement='top'
          overlay={
            <Popover id={`popover-positioned-top`}>
              <Popover.Content>{Url}</Popover.Content>
            </Popover>
          }
        >
          <MarkIcon style={{ fontSize: 24, color: Color }} />
        </OverlayTrigger>
      ) : (
        <OverlayTrigger
          trigger='hover'
          rootClose
          placement='top'
          overlay={
            <Popover id={`popover-positioned-top`}>
              <Popover.Content>{Text}</Popover.Content>
            </Popover>
          }
        >
          <MarkIcon
            style={{ fontSize: 24, color: Color }}
            onClick={() => window.open(Url)}
          />
        </OverlayTrigger>
      )}
    </div>
  )
}
